import React from "react";

export const InstagramLogo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.1515C13.6569 15.1515 15 13.7948 15 12.1212C15 10.4477 13.6569 9.09094 12 9.09094C10.3431 9.09094 9 10.4477 9 12.1212C9 13.7948 10.3431 15.1515 12 15.1515Z"
        fill="#ECEFF2"
      />
      <path
        d="M16.125 2.65149H7.875C6.48261 2.65149 5.14726 3.2102 4.16269 4.20471C3.17812 5.19922 2.625 6.54807 2.625 7.95452V16.2879C2.625 17.6943 3.17812 19.0431 4.16269 20.0377C5.14726 21.0322 6.48261 21.5909 7.875 21.5909H16.125C17.5174 21.5909 18.8527 21.0322 19.8373 20.0377C20.8219 19.0431 21.375 17.6943 21.375 16.2879V7.95452C21.375 6.54807 20.8219 5.19922 19.8373 4.20471C18.8527 3.2102 17.5174 2.65149 16.125 2.65149ZM12 16.6666C11.11 16.6666 10.24 16.4001 9.49993 15.9006C8.75991 15.4011 8.18314 14.6912 7.84254 13.8607C7.50195 13.0301 7.41283 12.1161 7.58647 11.2344C7.7601 10.3527 8.18868 9.54276 8.81802 8.90706C9.44736 8.27137 10.2492 7.83846 11.1221 7.66307C11.995 7.48768 12.8998 7.5777 13.7221 7.92173C14.5443 8.26577 15.2471 8.84837 15.7416 9.59587C16.2361 10.3434 16.5 11.2222 16.5 12.1212C16.5 13.3267 16.0259 14.4829 15.182 15.3353C14.3381 16.1877 13.1935 16.6666 12 16.6666ZM16.875 8.33331C16.6525 8.33331 16.435 8.26666 16.25 8.1418C16.065 8.01693 15.9208 7.83945 15.8356 7.63181C15.7505 7.42417 15.7282 7.19568 15.7716 6.97525C15.815 6.75482 15.9222 6.55234 16.0795 6.39341C16.2368 6.23449 16.4373 6.12626 16.6555 6.08241C16.8738 6.03857 17.1 6.06107 17.3055 6.14708C17.5111 6.23309 17.6868 6.37874 17.8104 6.56561C17.934 6.75249 18 6.97219 18 7.19694C18 7.49833 17.8815 7.78736 17.6705 8.00047C17.4595 8.21358 17.1734 8.33331 16.875 8.33331Z"
        fill="#ECEFF2"
      />
    </svg>
  );
};
